import React from "react";

export interface TabPanelProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  index: any;
  value: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, style, value, index, ...other } = props;

  return (
    <div
      style={style}
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (children)}
    </div>
  );
};

export default TabPanel;
